import {ValidationError} from './validation-error-check';

/*
 * This function takes a ValidationError and converts it into an object of the form that can
 * be used in redux-form as its standard error object, where `_error` is the global error key,
 * and field-level errors get their own keys.
 */
export function makeErrorObject(error: any) {
    if (!error || !(error instanceof ValidationError)) return {};

    // @ts-ignore
    if (Array.isArray(error.validationResult.messages)) {
        return {
            // @ts-ignore
            _error: error.validationResult.messages[0],
        };
    }

    // @ts-ignore
    return error.validationResult.messages;
}
